export const parseZipCode = ({ street, neighborhood, state, city }) => ({
  address: street?.split('-')[0].trim(),
  district: neighborhood,
  state,
  city
})
